import { render, staticRenderFns } from "./Promos.vue?vue&type=template&id=807c2844&scoped=true"
import script from "./Promos.vue?vue&type=script&lang=js"
export * from "./Promos.vue?vue&type=script&lang=js"
import style0 from "./Promos.vue?vue&type=style&index=0&id=807c2844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807c2844",
  null
  
)

export default component.exports